<template>
  <div
    class="page pb-8">
    <p class="page__logo">
      <img
        src="@/assets/images/logo@2x.png">
    </p>
    <div class="px-5 mt-3">
      <h2 class="d-flex justify-content-center">
        メンテナンス中
      </h2>
      <div
        class="maintenance-card mt-3">
        <div
          v-if="maintenanceInfo"
          class="maintenance-card__text">
          {{ maintenanceInfo.text }}
        </div>
        <div v-else>
          現在システムメンテナンス中です。大変申し訳ございません。メンテナンスが終わるまでしばらくお待ちください。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('maintenance', ['maintenanceInfo'])
  }
}
</script>

<style scoped lang="scss">
.maintenance-card {
  background-color: $white;
  border-radius: 8px;
  border: solid 1px $grey10;
  padding: 8px;
  &__text {
    white-space: pre-line;
    color: $grey04;
  }
}

</style>